import React, { useState, useEffect } from 'react';
import { Slider, Select, Switch, Tooltip } from './UI';
// Remove Material-UI imports or comment them out
// import { Switch } from '@mui/material';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import FormControlLabel from '@mui/material/FormControlLabel';
import { FaInfoCircle, FaLightbulb } from 'react-icons/fa';

const ControlPanel = ({ model, onParameterChange }) => {
  const [showTooltips, setShowTooltips] = useState(false);
  
  const handleSlipChange = (value) => {
    onParameterChange('slip', value);
  };
  
  const handleDriveTypeChange = (value) => {
    onParameterChange('driveType', value);
  };
  
  const handleControlModeChange = (value) => {
    onParameterChange('controlMode', value);
  };
  
  const handleLoadChange = (value) => {
    onParameterChange('loadTorque', value);
  };
  
  return (
    <div className="control-panel glass-panel">
      <div className="panel-header">
        <h2>Control Panel</h2>
        <Switch 
          checked={showTooltips} 
          onChange={() => setShowTooltips(!showTooltips)} 
          label="Learning Mode"
        />
      </div>
      
      <div className="control-group">
        <label>
          Drive Type
          {showTooltips && (
            <Tooltip content="Scherbius uses AC-DC-AC conversion to feed power back to the grid. Kramer uses a DC motor to recover slip power mechanically.">
              <FaInfoCircle />
            </Tooltip>
          )}
        </label>
        <Select
          options={[
            { value: 'scherbius', label: 'Scherbius Drive' },
            { value: 'kramer', label: 'Kramer Drive' },
          ]}
          value={model.driveType}
          onChange={handleDriveTypeChange}
        />
      </div>
      
      <div className="control-group">
        <label>
          Slip (%)
          {showTooltips && (
            <Tooltip content="Slip is the difference between synchronous speed and actual rotor speed, expressed as a percentage of synchronous speed.">
              <FaInfoCircle />
            </Tooltip>
          )}
        </label>
        <Slider
          min={0}
          max={100}
          value={model.slip * 100}
          onChange={(val) => handleSlipChange(val / 100)}
          showValue
          unit="%"
        />
      </div>
      
      <div className="control-group">
        <label>
          Load Torque
          {showTooltips && (
            <Tooltip content="The mechanical load applied to the motor shaft.">
              <FaInfoCircle />
            </Tooltip>
          )}
        </label>
        <Slider
          min={0}
          max={200}
          value={model.loadTorque}
          onChange={handleLoadChange}
          showValue
          unit="Nm"
        />
      </div>
      
      <div className="control-group">
        <label>
          Control Mode
          {showTooltips && (
            <Tooltip content="Open loop has no feedback. Closed loop uses feedback to maintain desired speed regardless of load changes.">
              <FaInfoCircle />
            </Tooltip>
          )}
        </label>
        <Select
          options={[
            { value: 'open', label: 'Open Loop' },
            { value: 'closed', label: 'Closed Loop (PID)' },
          ]}
          value={model.controlMode}
          onChange={handleControlModeChange}
        />
      </div>
    </div>
  );
};

export default ControlPanel;